exports = module.exports = require("../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".layoutConfig[data-v-224d4ed7] {\n  background-color: #30b8a6 !important;\n  color: #ffffff;\n  border: none;\n}", ""]);

// exports
